@for (link of links; track getLinkId($index, link)) {
  <div class="pm-link-bubble" [style.background-color]="linkColor(link)" [class.highlight]="highlight(link)"
       (click)="clicked($event, link)" [matTooltip]="getTooltip(link)" matTooltipPosition="above"
       [matTooltipDisabled]="!!node.activation" (contextmenu)="prevent()">
  </div>
}

@if ((showBackLinks$ | async) && backLinks?.length > 0) {
  @let firstLink = backLinks[0];
  @if (backLinks?.length === 1) {
    <div class="pm-link-bubble" [class.isDark]="isDark(firstLink)" [style.background-color]="linkColor(firstLink)"
         (click)="clicked($event, firstLink)" [matTooltip]="getBackLinkLabel(firstLink) | async" matTooltipPosition="above"
         [matTooltipDisabled]="!!node.activation" (contextmenu)="prevent()">
      <mat-icon inline>arrow_back</mat-icon>
    </div>
  } @else {
    <div class="pm-link-bubble" [matMenuTriggerFor]="backLinksMenu" [class.isDark]="isDark(firstLink)" [style.background-color]="linkColor(firstLink)"
         [matTooltip]="'link-overlay.backlinks.multiple.tooltip' | translate:{size: backLinks.length}" matTooltipPosition="above" [matTooltipDisabled]="!!node.activation" (contextmenu)="prevent()">
      <mat-icon inline>arrow_back</mat-icon>
    </div>
  }

  <mat-menu #backLinksMenu="matMenu" class="backlinks-menu" [hasBackdrop]="true">
    @for (link of backLinks; track getLinkId($index, link)) {
      <button mat-menu-item (click)="clicked($event, link)">
        <mat-icon class='backlink-icon' [style.background-color]="linkColor(link)">arrow_back</mat-icon>
        <span>{{getBackLinkLabel(link) | async}}</span>
      </button>
    }
  </mat-menu>
}
